export const arrows = `
<div class="garrows c-slider-arrows">
  <button class="gnext gbtn" aria-label="Next">{nextSVG}</button>
  <button class="gprev gbtn" aria-label="Previous">{prevSVG}</button>
  <button class="gbtn-custom gbtn-custom--prev c-slider-arrows__arrow c-slider-arrows__arrow--prev js-glightbox-arrow-prev ui-transition" tabindex="0" aria-label="Next">
    <svg class="ui-transition" width="14" height="12" viewBox="0 0 14 12" fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.125 0.374939L7.32062 1.1585L11.5844 5.43744H0.25V6.56244H11.5844L7.32062 10.8223L8.125 11.6249L13.75 5.99994L8.125 0.374939Z"
        fill="currentColor" />
    </svg>
  </button>
  <button class="gbtn-custom gbtn-custom--next c-slider-arrows__arrow c-slider-arrows__arrow--next js-glightbox-arrow-next ui-transition" tabindex="1" aria-label="Previous">
    <svg class="ui-transition" width="14" height="12" viewBox="0 0 14 12" fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.125 0.374939L7.32062 1.1585L11.5844 5.43744H0.25V6.56244H11.5844L7.32062 10.8223L8.125 11.6249L13.75 5.99994L8.125 0.374939Z"
        fill="currentColor" />
    </svg>
  </button>
</div>`;

export const customLightboxHTML = `
  <div id="glightbox-body" class="glightbox-container glightbox-container--custom">
    <button class="gclose gbtn ui-transition" tabindex="2" aria-label="Close"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="23.2038" height="1.9889" transform="matrix(0.704732 0.709473 -0.704732 0.709473 10.4014 8)" fill="white"/><rect width="23.2038" height="1.9889" transform="matrix(-0.704732 0.709473 0.704732 0.709473 25.5986 8)" fill="white"/></svg></button>
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
      <div id="glightbox-slider" class="gslider"></div>
      ${arrows}
    </div>
  </div>`;

export const customSlideHTML = `<div class="gslide gslide--custom">
    <div class="gslide-inner-content">
        <div class="ginner-container">
          <div class="gslide-description">
            <div class="gdesc-inner">
                <span class="gslide-number">
                  <span class="gslide-number-current t-typo-h4"></span>
                  <span class="gslide-number-separator t-typo-h4">/</span>
                  <span class="gslide-number-all t-typo-h5"></span>
                </span>
                <h4 class="gslide-title gslide-title--custom"></h4>
                <div class="gslide-desc gslide-desc--custom"></div>
            </div>
          </div>

          <div class="gslide-media"></div>
        </div>
    </div>
</div>`;
